export const API_EMPLOYEES_IMPORTS_TEMPLATE_PATH_KEY = '/employees-imports/template';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_FILE_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/file';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/abort';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_PATH_KEY =
  '/organizations/{organizationId}/employees-imports';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/overview';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/records';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_RECORDID_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/records/{recordId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_COMMIT_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/records/commit';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_ABORT_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/records/abort';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY =
  '/organizations/{organizationId}/employees-imports/{jobId}/records/stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_ME_PATH_KEY =
  '/organizations/{organizationId}/employees/me';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY =
  '/organizations/{organizationId}/employees';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_SEARCH_PATH_KEY =
  '/organizations/{organizationId}/employees/search';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY =
  '/organizations/{organizationId}/employees/filters';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY =
  '/organizations/{organizationId}/employees/stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY =
  '/organizations/{organizationId}/employees/email-already-exist';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY =
  '/organizations/{organizationId}/employees/delete-check';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY =
  '/organizations/{organizationId}/employees/{employeeId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY =
  '/organizations/{organizationId}/employees/{employeeId}/account/enable';
export const API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_DISABLE_PATH_KEY =
  '/organizations/{organizationId}/employees/{employeeId}/account/disable';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_PATH_KEY =
  '/organizations/{organizationId}/departments';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY =
  '/organizations/{organizationId}/departments/assign-check';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY =
  '/organizations/{organizationId}/departments/{departmentId}/assign';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_MEMBERS_PATH_KEY =
  '/organizations/{organizationId}/departments/{departmentId}/members';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_MEMBERS_PATH_KEY =
  '/organizations/{organizationId}/departments/members';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY =
  '/organizations/{organizationId}/departments/{departmentId}/teams';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY =
  '/organizations/{organizationId}/departments/{departmentId}/teams/{teamId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_MEMBERS_PATH_KEY =
  '/organizations/{organizationId}/departments/{departmentId}/teams/{teamId}/members';
export const API_INTERNAL_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEE_ACCOUNTS_PATH_KEY =
  '/internal/organizations/{organizationId}/employee-accounts';
export const API_ADMIN_ORGANIZATIONS_ORGANIZATIONID_ACCOUNT_SEARCH_PATH_KEY =
  '/admin/organizations/{organizationId}/account/search';
export const API_INTERNAL_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_RESOLVE_PATH_KEY =
  '/internal/organizations/{organizationId}/employees/resolve';
